<div class="ai-multi-select">
    <!-- Gatilho -->
    <div
        #selection
        class="ai-multi-select__select"
        [ngClass]="{ 'ai-is-disabled': disabled(), 'ai-is-open': optionsVisible() }"
        role="combobox"
        [attr.aria-expanded]="optionsVisible()"
        aria-haspopup="listbox"
        (click)="changeVisibility()"
    >
        <div class="ai-multi-select__value">
            @if (hasSelection()) {
                @for (chip of chips(); track chip.value) {
                    <span class="ai-multi-select__chip">
                        <span class="ai-multi-select__chip-label">{{ chip.label }}</span>
                        @if (!disabled()) {
                            <button
                                type="button"
                                class="ai-multi-select__chip-remove"
                                [attr.aria-label]="'Remover ' + chip.label"
                                (click)="removeChip(chip, $event)"
                            >
                                <ai-icon [fontIcon]="'fa-solid fa-xmark'" />
                            </button>
                        }
                    </span>
                }
                @if (extraCount() > 0) {
                    <span class="ai-multi-select__more">+{{ extraCount() }}</span>
                }
            } @else {
                <span class="ai-multi-select__placeholder">{{ placeholder() }}</span>
            }
        </div>

        <div class="ai-multi-select__indicators">
            @if (hasSelection() && !disabled()) {
                <button
                    type="button"
                    class="ai-multi-select__clear"
                    aria-label="Limpar seleção"
                    (click)="clearAll($event)"
                >
                    <ai-icon [fontIcon]="'fa-solid fa-xmark'" />
                </button>
            }
            <ai-icon
                class="ai-multi-select__caret"
                [fontIcon]="'fa-solid fa-angle-down'"
            />
        </div>
    </div>

    <!-- Painel de opções -->
    @if (optionsVisible()) {
        <div
            #optionBox
            class="ai-multi-select__option-list"
            role="listbox"
            aria-multiselectable="true"
            [@multiSelectFade]
            [style.top.px]="panelTop()"
            [style.left.px]="panelLeft()"
            [style.width.px]="panelWidth()"
            [style.maxHeight.px]="panelMaxHeight()"
        >
            @if (showSearch()) {
                <div class="ai-multi-select__search">
                    <ai-icon
                        class="ai-multi-select__search-icon"
                        [fontIcon]="'fa-solid fa-magnifying-glass'"
                    />
                    <input
                        type="text"
                        class="ai-multi-select__search-input"
                        [placeholder]="searchPlaceholder()"
                        [value]="searchTerm()"
                        (input)="onSearchInput($any($event.target).value)"
                        (click)="$event.stopPropagation()"
                    />
                </div>
            }

            <div class="ai-multi-select__scroll">
                @if (selectAllOption() && !searchTerm()) {
                    <div
                        class="ai-multi-select__option ai-separator"
                        [ngClass]="{ 'ai-is-selected': selectAllOption()?.selected }"
                        (click)="onAllSelected()"
                    >
                        <input
                            type="checkbox"
                            tabindex="-1"
                            [checked]="selectAllOption()?.selected"
                        />
                        <span>{{ selectAllOption()?.label }}</span>
                    </div>
                }

                @for (
                    option of filteredOptions();
                    track option.value;
                    let i = $index
                ) {
                    <div
                        class="ai-multi-select__option"
                        role="option"
                        [attr.aria-selected]="option.selected"
                        [ngClass]="{
                            'ai-is-selected': option.selected,
                            'ai-is-active': i === activeIndex()
                        }"
                        (click)="onCheckboxChanged(option)"
                    >
                        <input
                            type="checkbox"
                            tabindex="-1"
                            [checked]="option.selected"
                        />
                        <span>{{ option.label }}</span>
                    </div>
                }

                @if (filteredOptions().length === 0) {
                    <div class="ai-multi-select__empty">{{ emptyText() }}</div>
                }
            </div>
        </div>
    }
</div>
